<template>
    <div>
        <div class="ppv2-w-full">
            <h3 class="ppv2-text-center ppv2-text-blue-500 ppv2-text-2xl poppinsSemiBold">
                {{ $t('form_customer_v2.addresses.title') }}
            </h3>
        </div>

        <form>
            <div class="ppv2-w-full ppv2-grid ppv2-grid-cols-2 ppv2-mt-2 ppv2-mb-2" :style="{ gap: normalizeSize(16, true) }">
                <BaseInput
                    v-model="object_adress.country"
                    ref="country"
                    :error="errors.country"
                    :state="errors.country ? 'error' : 'default'"
                    :label="$t('form_customer_v2.addresses.country.label')"
                    :placeholder="$t('form_customer_v2.addresses.country.placeholder')"
                    required
                />

                <BaseInput
                    v-model="object_adress.city"
                    ref="city"
                    :label="$t('form_customer_v2.addresses.city.label')"
                    :placeholder="$t('form_customer_v2.addresses.city.placeholder')"
                    :error="errors.city"
                    :state="errors.city ? 'error' : 'default'"
                    required
                />
            </div>

            <div class="ppv2-w-full ppv2-grid ppv2-grid-cols-2 ppv2-mt-2 ppv2-mb-2" :style="{ gap: normalizeSize(16, true) }">
                <BaseInput
                    v-model="object_adress.street"
                    ref="street"
                    :error="errors.street"
                    :state="errors.street ? 'error' : 'default'"
                    :label="$t('form_customer_v2.addresses.address.label')"
                    :placeholder="$t('form_customer_v2.addresses.address.placeholder')"
                    required
                />

                <BaseInput
                    v-model="object_adress.postal_code"
                    ref="postal_code"
                    :error="errors.postal_code"
                    :state="errors.postal_code ? 'error' : 'default'"
                    :label="$t('form_customer_v2.addresses.zip_code.label')"
                    :placeholder="$t('form_customer_v2.addresses.zip_code.placeholder')"
                    required
                />
            </div>
        </form>
    </div>
</template>

<script>
import BaseInput from '../../Shared/BaseInput.vue'
import ApiManager from '../Api/v2/ApiManagerBoCutomer.js'
import normalizeSize from '../../../utils/normalizeSize.js'
export default {
    props: ['user', 'adresse', 'hasEdit'],
    components: { BaseInput },
    data() {
        const defaultAddress = {
            country: '',
            city: '',
            street: '',
            postal_code: '',
            user_id: 0,
        }

        return {
            errors: {
                country: '',
                city: '',
                street: '',
                postal_code: '',
            },
            object_adress: this.hasEdit && this.adresse ? JSON.parse(JSON.stringify(this.adresse)) : { ...defaultAddress },
        }
    },
    methods: {
        normalizeSize,
        showMessageNotification(message, type) {
            this.$toast[type](message)
        },
        reset() {
            this.object_adress = {
                country: '',
                city: '',
                street: '',
                postal_code: '',
                user_id: this.user?.id || 0,
            }
        },
        validate() {
            this.errors.country = ''
            this.errors.city = ''
            this.errors.street = ''
            this.errors.postal_code = ''

            let valid = true
            let firstErrorField = null

            if (!this.object_adress.country) {
                this.errors.country = this.$t('form_customer_v2.addresses.country.required')
                valid = false
                if (!firstErrorField) firstErrorField = 'country'
            }

            if (!this.object_adress.city) {
                this.errors.city = this.$t('form_customer_v2.addresses.city.required')
                valid = false
                if (!firstErrorField) firstErrorField = 'city'
            }

            if (!this.object_adress.street) {
                this.errors.street = this.$t('form_customer_v2.addresses.address.required')
                valid = false
                if (!firstErrorField) firstErrorField = 'street'
            }

            if (!this.object_adress.postal_code) {
                this.errors.postal_code = this.$t('form_customer_v2.addresses.zip_code.required')
                valid = false
                if (!firstErrorField) firstErrorField = 'postal_code'
            }

            if (firstErrorField) {
                this.scrollToError(firstErrorField)
            }

            return valid
        },
        scrollToError(refName) {
            const el = this.$refs[refName]?.$el || this.$refs[refName]
            if (el && typeof el.scrollIntoView === 'function') {
                el.scrollIntoView({
                    behavior: 'smooth',
                    block: 'center',
                })
            }
        },
    },
    mounted() {
        if (this.user?.id) {
            this.object_adress.user_id = this.user.id
        }
    },
}
</script>
